var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkAccess('sites'))?_c('report-list-page',{attrs:{"page-title":"Site Report","page-icon":"business","descending":true,"headers":_vm.headers,"state-end-point":"invoice.invoices","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"detailId","sort":"invoiceNo"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }